import {
  PropertyType,
  useBidInterestApi,
} from "../../../../hoc/useBidInterestApi";
import { useDownloadDocumentApi } from "../../../../hoc/useDownloadDocumentApi";

interface DownloadPayloadInterface {
  propertyUuid: string;
  resolvedName: string;
  resolvedMobile: string;
  resolvedEmail: string;
  propertyType: PropertyType;
  propertyListingId: string;
}

export function useDownloadAllCta({
  onDownloadAllDocumentsWhenUserMobileNotExistsCallback = () => {},
}: {
  onDownloadAllDocumentsWhenUserMobileNotExistsCallback?: () => void;
}) {
  const { execute: triggerDownloadPropertyDocumentApi } =
    useDownloadDocumentApi();
  const { execute: triggerBidInterestApi } = useBidInterestApi();

  const handleDownloadAllDocumentsWhenUserMobileExist = ({
    propertyUuid,
    resolvedName,
    resolvedMobile,
    resolvedEmail,
    propertyType,
    propertyListingId,
  }: DownloadPayloadInterface) => {
    triggerBidInterestApi({
      propertyType,
      requestType: `download_all_${propertyType}_documents`,
      propertyListingId: propertyListingId,
      remark: "",
      userMobile: resolvedMobile,
      userEmail: resolvedEmail,
      userName: resolvedName,
    });
    triggerDownloadPropertyDocumentApi(
      {
        propertyUuid,
        userName: resolvedName,
        userEmail: resolvedEmail,
        userMobile: resolvedMobile,
        singleFileDownload: false,
      },
      {
        onSuccess: () => {},
        onError: () => {},
      },
    );
  };

  const handleDownloadAllDocumentsWhenUserMobileNotExists = ({
    resolvedName,
    resolvedMobile,
    resolvedEmail,
    propertyType,
    propertyListingId,
  }: Omit<DownloadPayloadInterface, "propertyUuid">) => {
    triggerBidInterestApi({
      propertyType,
      requestType: `download_all_${propertyType}_documents`,
      propertyListingId: propertyListingId,
      remark: "",
      userMobile: resolvedMobile,
      userEmail: resolvedEmail,
      userName: resolvedName,
    });
    onDownloadAllDocumentsWhenUserMobileNotExistsCallback?.();
  };

  return {
    handleDownloadAllDocumentsWhenUserMobileExist,
    handleDownloadAllDocumentsWhenUserMobileNotExists,
  };
}
